import React from "react";
import Select from "react-select";
import assignIn from "lodash/assignIn";
import { observer } from "mobx-react";

interface Option {
  value: string;
  label: string;
}

interface ReactSelectWrapProps {
  options: Option[];
  reactSelectProps: object;
  selectedModel: string;
  onChange?: Function;
}

@observer
class ServicePlanReactSelectWrap extends React.Component<ReactSelectWrapProps> {
  get filteredProps() {
    //Ensure we don't overwrite props the Wrap needs to control
    const filtered = assignIn({}, this.props.reactSelectProps);
    delete filtered.onChange;
    delete filtered.value;
    delete filtered.options;

    return filtered;
  }
  constructor(props: ReactSelectWrapProps) {
    super(props);
  }

  render() {
    return (
      <Select
        {...this.filteredProps}
        value={
          this.props.options.find(
            (x) =>
              x.value.toLocaleLowerCase() ===
              this.props.selectedModel.toLocaleLowerCase()
          ).value
        }
        onChange={(choice) => {
          this.setState({ choice });
          if (this.props.onChange) this.props.onChange.call(this, choice);
        }}
        options={this.props.options}
      />
    );
  }
}

export default ServicePlanReactSelectWrap;
